import { Pipe, PipeTransform } from '@angular/core';
import { DataObject } from '@shared/models/data-object.model';
import { SortEvent } from '@shared/models/sort-event';
import { sortAscFactory, sortDesFactory } from '@shared/services/sorting.service';

export type SortFunction = (a: DataObject, b: DataObject) => number;

/**
 * @deprecated use 'sort' pipe instead from @miq/utils/pipes
 */
@Pipe({
  name: 'sortBy',
  standalone: false,
})
export class SortByPipe implements PipeTransform {
  transform(elements: DataObject[], sortEvent?: SortEvent | SortFunction): any {
    elements = elements || [];
    if (typeof sortEvent === 'function') {
      return elements.sort(sortEvent);
    }
    const sortingFactory = sortEvent.sortOrder === 1 ? sortAscFactory : sortDesFactory;
    const sortFn = sortingFactory(sortEvent.sortBy);
    return elements.sort(sortFn);
  }
}
